<template>
  <div class="h-96 flex items-center">
    <div class="text-3xl mx-auto">
      404: Page Not Found
    </div>
  </div>
</template>

<script>
export default {};
</script>
